import { _, allRoles, isAuthorized, lazyLoadView, piloteAndAuditor, piloteOnly, setNavL2 } from '@/router/routing'
import type { Route, RouteConfig } from 'vue-router'
import {
  ACTION_PLANS_ROUTE_NAME,
  ACTION_PLAN_ROUTE_NAME,
  ACTION_PLAN_LABEL_ROUTE_NAME,
} from '@/contexts/action-plans/ActionPlans.constants'

export const actionPlansRoutes: RouteConfig = {
  path: '/actions',
  name: ACTION_PLANS_ROUTE_NAME,
  component: () => lazyLoadView(import('@/contexts/action-plans/ActionPlansListView.vue')),
  meta: {
    i18nTitle: 'action_plans.menu.title',
    icon: 'stream',
    is_authorized: (route: Route) => isAuthorized(route),
    requires_auth: true,
    requires_tenant: true,
    requires_role: piloteAndAuditor,
    doc_id: 'action_register',
  },
  children: [
    {
      path: ':id',
      name: ACTION_PLAN_ROUTE_NAME,
      component: () => lazyLoadView(import('@/contexts/action-plans/ActionPlansActionsView.vue')),
      meta: {
        title: null,
        icon: 'stream',
        is_authorized: (route: Route) => isAuthorized(route),
        requires_auth: true,
        requires_tenant: true,
        requires_role: piloteAndAuditor,
        doc_id: 'action_register_details',
      },
      children: [
        {
          path: 'mapping',
          name: 'actionRegistersMapping',
          component: () => lazyLoadView(import('@/contexts/action-plans/ActionPlansMappingView.vue')),
          meta: {
            title: null,
            is_authorized: (route: Route) => isAuthorized(route),
            requires_auth: true,
            requires_tenant: true,
            requires_role: piloteOnly,
            doc_id: 'action-registers-mapping',
          },
        },
      ],
    },
    {
      path: 'label/list',
      name: ACTION_PLAN_LABEL_ROUTE_NAME,
      component: () => lazyLoadView(import('@/contexts/action-plans/ActionPlansActionsView.vue')),
      meta: {
        title: null,
        icon: 'stream',
        is_authorized: (route: Route) => isAuthorized(route),
        requires_auth: true,
        requires_tenant: true,
        requires_role: piloteAndAuditor,
        doc_id: 'action_register_details',
      },
    },
    {
      path: 'filtered/list',
      name: 'filteredaction',
      component: () => lazyLoadView(import('@/contexts/action-plans/ActionPlansAdvancedFiltersView.vue')),
      meta: {
        title: _('Advanced search'),
        icon: 'stream',
        is_authorized: (route: Route) => isAuthorized(route),
        requires_auth: true,
        requires_tenant: true,
        requires_role: piloteAndAuditor,
        doc_id: 'action_filtered_details',
      },
    },
  ],
}

export const actionPlansContributionRoutes: RouteConfig = {
  path: 'local_actions',
  name: 'local_actions',
  component: () => lazyLoadView(import('@/contexts/action-plans/contributions/ContributionsActionPlansView.vue')),
  beforeEnter: setNavL2,
  meta: {
    title: _('Actions'),
    icon: 'stream',
    is_authorized: (route: Route) => isAuthorized(route),
    requires_auth: true,
    requires_tenant: true,
    requires_role: allRoles,
    doc_id: 'local_action_register',
    nb_contribution: 'nb_actions',
  },
  children: [
    {
      path: ':id',
      name: 'local_action_registers',
      component: () => lazyLoadView(import('@/contexts/action-plans/contributions/ContributionsActionsView.vue')),
      meta: {
        title: null,
        is_authorized: (route: Route) => isAuthorized(route),
        requires_auth: true,
        requires_tenant: true,
        requires_role: allRoles,
        doc_id: 'local_action_registers_details',
      },
    },
  ],
}
